import classNames from 'classnames'
import { t } from 'i18next'
import { FormInput, IconFa, IconLoading } from '../../atoms'

export interface SearchFieldProps {
  searchPhrase: string
  label?: string
  setSearchPhrase: (value: string) => void
  className?: string
  placeholder?: string
  isSearching?: boolean
}

export const SearchField = ({
  searchPhrase,
  label,
  setSearchPhrase,
  className,
  placeholder = t('glow.search'),
  isSearching
}: SearchFieldProps) => (
  <FormInput
    icon={isSearching ? <IconLoading /> : <IconFa icon={['far', 'magnifying-glass']} />}
    label={label}
    className={classNames('max-w-4xl mt-2', className)}
    value={searchPhrase}
    placeholder={placeholder}
    type="search"
    onClear={() => setSearchPhrase('')}
    onChange={(event) => setSearchPhrase((event.target as HTMLInputElement).value)}
  />
)
